import React, { useState } from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';

import ScrapeCsvTable from './ScrapeCsvTable';
import { DailyDiscountStats, DailyMarketStats, ParsedOtaCsv } from './otaParity/types';

interface Props {
  open: boolean;
  onClose: () => void;
  parsed: ParsedOtaCsv;
  marketStats: Array<DailyMarketStats>;
  discountStats: Array<DailyDiscountStats>;
  currencyCode: string;
}

export default function RawCsvDataTable({ open, onClose, parsed, marketStats, discountStats, currencyCode }: Props) {
  const [dateFilter, setDateFilter] = useState('');

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} PaperProps={{ sx: { width: '95vw', height: '90vh' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h6">Raw CSV data</Typography>
          <Typography variant="caption" color="textSecondary">
            {parsed.rows.length} dates · {parsed.otaColumns.length} OTA channels
            {parsed.leFlashColumn ? ' · LE (Live Flash) column included' : ''}
          </Typography>
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
          <TextField
            size="small"
            placeholder="Filter by date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          />
          <Typography variant="caption" color="textSecondary">
            Sell vs Min OTA is the only colour-graded column (red → white → green, anchored at the column&apos;s
            min/median/max)
          </Typography>
        </Box>

        <ScrapeCsvTable
          parsed={parsed}
          marketStats={marketStats}
          discountStats={discountStats}
          currencyCode={currencyCode}
          maxHeight="calc(90vh - 180px)"
          dateFilter={dateFilter}
        />
      </DialogContent>
    </Dialog>
  );
}
